import React, { useState, useEffect } from "react";
import { i18n } from "@lingui/core";
import { t } from "@lingui/macro";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LinearProgress from "@mui/material/LinearProgress";

// Local storage key to track if a user has seen the GDPR dialog
const GDPR_CONSENT_KEY = "gdpr_consent_viewed";

export default function GDPRConsentDialog() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if anyone has viewed the GDPR consent dialog before
    const hasViewedConsent = localStorage.getItem(GDPR_CONSENT_KEY);

    if (!hasViewedConsent) {
      // Wait a moment after page load to show the dialog
      const timer = setTimeout(() => {
        setOpen(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setLoading(true);

    // Save consent to localStorage - no user ID needed
    localStorage.setItem(GDPR_CONSENT_KEY, "true");

    // Simulate a brief loading state
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 300);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="gdpr-consent-title"
      aria-describedby="gdpr-consent-description"
    >
      {loading && <LinearProgress />}
      <DialogTitle id="gdpr-consent-title">
        {i18n._(t`Data Usage Consent`)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="gdpr-consent-description">
          <Typography paragraph>
            {i18n._(
              t`We use cookies and similar technologies to provide certain features, enhance the user experience and deliver content that is relevant to your interests.`
            )}
          </Typography>
          <Typography paragraph>
            {i18n._(
              t`By clicking "I Accept", you allow us to collect and process information necessary to provide you with the best possible app experience, including personalized features and improved functionality.`
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ m: 2 }}>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={handleAccept}
          fullWidth
        >
          {i18n._(t`I Accept`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
